import { z } from 'zod';

export const addressInputSchema = z.object({
  label: z.string().min(1).max(40).optional(),
  recipient: z.string().min(2, 'Nama penerima minimal 2 karakter').max(120),
  phone: z.string().min(8, 'Nomor telepon minimal 8 digit').max(24),

  // Id wilayah mengikuti RajaOngkir; namanya ikut disimpan sebagai snapshot.
  provinceId: z.string().min(1).max(16),
  provinceName: z.string().min(1).max(80),
  cityId: z.string().min(1).max(16),
  cityName: z.string().min(1).max(120),
  district: z.string().min(1).max(120).optional(),

  // Id wilayah level kelurahan dari Komerce/RajaOngkir V2, dipakai menghitung
  // ongkir. Opsional supaya alamat lama tetap lolos validasi, tapi wajib ada
  // sebelum alamat bisa dipakai checkout.
  destinationId: z.number().int().positive().optional(),
  destinationLabel: z.string().min(1).max(200).optional(),

  postalCode: z.string().min(5, 'Kode pos 5 digit').max(10),
  line: z.string().min(10, 'Alamat terlalu pendek').max(500),
  note: z.string().max(200).optional(),
  isDefault: z.boolean().optional(),
});

export const addressUpdateSchema = addressInputSchema
  .partial()
  .refine((data) => Object.keys(data).length > 0, {
    message: 'Tidak ada perubahan yang dikirim',
  });

export const addressParamsSchema = z.object({
  addressId: z.string().min(1).max(64),
});

export type AddressInput = z.infer<typeof addressInputSchema>;
export type AddressUpdate = z.infer<typeof addressUpdateSchema>;
export type AddressParams = z.infer<typeof addressParamsSchema>;
